import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'uex-try-again',
  templateUrl: './try-again.component.html',
  host: {
    class: 'uex-try-again'
  }
})
export class TryAgainComponent {
  @Input('text') text = 'NÃ£o foi possÃ­vel obter os dados.';
  @Input('buttonText') buttonText = 'Tentar novamente';

  @Output('onClick') clickEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    public elementRef: ElementRef
  ) { }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public onClick(event) {
    this.clickEvent.emit();
  }
}
